export const patchObject = (ob1: any, ob2: any): void => {
  const ob2Keys = Object.keys(ob2);
  Object.keys(ob1).forEach(property => {
    if (ob2Keys.includes(property)) {
      ob1[property] = ob2[property];
    }
  });
};

export function cloneObject<T>(ob1?: T): T | undefined {
  if (ob1) {
    return Object.assign({}, ob1) as T;
  } else {
    return undefined;
  }
}
